import { Pipe, PipeTransform, inject } from '@angular/core';
import { AUTH_SERVICE } from '@core/tokens/auth.tokens';

/**
 * Pipe que verifica si el usuario tiene un permiso específico.
 *
 * Uso:
 * ```html
 * <button [disabled]="!('users:write' | hasPermission)">Editar</button>
 * ```
 */
@Pipe({
  name: 'hasPermission',
  standalone: true,
  pure: false,
})
export class HasPermissionPipe implements PipeTransform {
  private readonly authService = inject(AUTH_SERVICE);

  transform(permission: string): boolean {
    return this.authService.hasPermission(permission);
  }
}
